import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as whistleBlowService from "../../services/whistleBlowService";
import { handleApiError } from "../storeEffects";
import { WhistleBlowAction, whistleBlowFailure, whistleBlowSuccess } from "./storeWhistleBlow";

//Effects
export type WhistleBlowThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, WhistleBlowAction>

export const getWhistleBlowPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return whistleBlowService.getWhistleBlowPage()
        .then(
            whistleBlowPage => {
                dispatch(whistleBlowSuccess(whistleBlowPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(whistleBlowFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};